import { RepositoryFactory } from "@/data/repositories/repositoryFactory";
import moment from "moment";

// initial state
const state = {
    failReasons: null,
    salesInvoices: null,
    tripStatusesByDay: null,
    tripStatusesByTimeRange: null,
    likumaInvoiceCreationTimestamp: null,
    emvInvoiceCreationTimestamp: null,
    taksiniInvoiceCreationTimestamp: null,
    likumaReadyForPurchaseInvoicingSummary: null,
    emvReadyForPurchaseInvoicingSummary: null,
    taksiniReadyForPurchaseInvoicingSummary: null,
    createdPurchaseInvoices: []
};

// actions
const actions = {
    async createSchedule({ commit }, obj) {
        await RepositoryFactory.get("cronScheduler").createCronSchedule(obj)
            .then(() => {
                commit("SET_CRON_SCHEDULE_CREATE_TIMESTAMP", moment());
            });
    },
    async updateSchedule({ commit }, obj) {
        await RepositoryFactory.get("cronScheduler").updateCronSchedule(obj)
            .then(() => {
                commit("SET_CRON_SCHEDULE_UPDATE_TIMESTAMP", moment());
            });
    },
    async deleteSchedule({ commit }, obj) {
        await RepositoryFactory.get("cronScheduler").deleteCronSchedule(obj)
            .then(() => {
                commit("SET_CRON_SCHEDULE_UPDATE_TIMESTAMP", moment());
            });
    },
    async getSchedule({ commit }, id) {
        const response = await RepositoryFactory.get("cronScheduler").getCronSchedule(id);
        commit("SET_CRON_SCHEDULE_GET_TIMESTAMP", moment());
        return response;
    },
    async getSchedules({ commit }) {
        const response = await RepositoryFactory.get("cronScheduler").getCronSchedules();
        commit("SET_CRON_SCHEDULE_GET_TIMESTAMP", moment());
        return response;
    }
};

const mutations = {
    SET_CRON_SCHEDULE_CREATE_TIMESTAMP(state, timestamp) {
        state.cronScheduleCreateTimestamp = timestamp;
    },
    SET_CRON_SCHEDULE_UPDATE_TIMESTAMP(state, timestamp) {
        state.cronScheduleUpdateTimestamp = timestamp;
    },
    SET_CRON_SCHEDULE_GET_TIMESTAMP(state, timestamp) {
        state.cronScheduleGetTimestamp = timestamp;
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};
